"use client"

import * as React from "react"
import { useProductAuthoringEnabled } from "./product-authoring-context"

/**
 * When builder authoring is on in dev, auto-writes `public/tenant-products.json`
 * so products + entities + hub table state survive hard refresh and clear site data.
 */
export function BuilderDevSync() {
  const authoring = useProductAuthoringEnabled()

  React.useEffect(() => {
    if (!authoring) return
    let stop = () => {}
    let cancelled = false

    void (async () => {
      const [
        { ensureShippedCatalogLoaded },
        { isBuilderDevSyncEnvironment, startBuilderDevSync },
      ] = await Promise.all([
        import("@exxatdesignux/product-framework/tenant-products/shipped-catalog"),
        import("@exxatdesignux/product-framework/tenant-products/builder-dev-sync"),
      ])
      if (cancelled || !isBuilderDevSyncEnvironment()) return
      await ensureShippedCatalogLoaded()
      if (cancelled) return
      stop = startBuilderDevSync()
    })()

    return () => {
      cancelled = true
      stop()
    }
  }, [authoring])

  return null
}
